import { render, staticRenderFns } from "./MensajeConfirmacionEliminarPersonalConvocatoria.vue?vue&type=template&id=9fcc1d14"
import script from "./MensajeConfirmacionEliminarPersonalConvocatoria.vue?vue&type=script&lang=js"
export * from "./MensajeConfirmacionEliminarPersonalConvocatoria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports